<template>
  <div class="piatto-box">
    <div class="left">
      <span class="dish-name">{{dish.name}}</span>
      <div v-bind:class="{'user-like': userLike}" v-on:tap="toggleLike()" class="like-count">
        <i class="rds-icon rds-icon-smile"></i>
        <span>{{dish.likes.length}} Like</span>
      </div>
    </div>
    <div class="order">
      <!-- <span class="preview-icon clickable" v-on:tap="decrement()">
        <img src="../assets/images/meno_vuoto.svg" alt />
      </span>
      <span
        class="preview-number"
        v-bind:class="{'not-selected': dish.orderQuantity===0}"
      >{{dish.orderQuantity}}</span>
      <span class="preview-icon clickable" v-on:tap="increment()">
        <img src="../assets/images/piu_vuoto.svg" alt />
      </span>-->
      <div v-on:tap="toggleCheck" class="orderCheckbox" v-bind:class="{checked:ordered}"></div>
      <!-- <input type="checkbox" v-model="ordered" name="orderCheckbox" class="orderCheckbox" /> -->
    </div>
  </div>
</template>
<script>
import userService from '../services/User.service';
export default {
  name: 'mensaDish',
  props: ['dish'],
  computed: {
    userLike() {
      return this.dish.likes.indexOf(userService.user.id) !== -1;
    },
    ordered() {
      return this.dish.orderQuantity > 0;
    }
  },
  methods: {
    toggleCheck() {
      this.dish.orderQuantity === 0 ? this.increment() : this.decrement();
    },
    increment() {
      this.dish.orderQuantity++;
    },
    decrement() {
      this.dish.orderQuantity--;
    },
    // toggleLike() {
    //   let added=userService.toggleLike('dishes', this.dish.id);

    //   const idx = this.likes.dishes.indexOf(this.dish.id);
    //   if (idx === -1) {
    //     this.dish.likes++;
    //     // this.likes.push(this.dish.id);
    //     userService.user.likes.dishes.push(this.dish.id);
    //   } else {
    //     this.dish.likes--;
    //     // this.likes.slice(idx, 1);
    //     userService.user.likes.dishes.slice(idx, 1);
    //   }
    // },
    toggleLike() {
      const added = userService.toggleLike('dishes', this.dish.id);
      if (added) {
        this.dish.likes.push(userService.user.id);
      } else {
        this.dish.likes.splice(this.dish.likes.indexOf(userService.user.id), 1);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.piatto-box {
  background-color: #ffffff;
  padding: 15px 20px;
  display: flex;
  @include shadow-bottom;
  @include dotted-bottom;
  &:last-child:after {
    content: none;
  }
  .left {
    margin: auto 0;
    max-width: 75%;
    overflow: hidden;
    line-height: 20px;
  }
  .dish-name {
    margin: 0 0 10px;
    display: inline-block;
    font-size: 0.95em;
    letter-spacing: 0.5px;
  }
  .order {
    margin: auto 0 auto auto;
    display: flex;
    align-items: center;
    // min-width: 65px;
    // max-width: 65px;
    .preview-number {
      margin: 0 4px;
      width: 19px;
      text-align: center;
      &.not-selected {
        color: rgba(96, 125, 139, 0.6);
      }
    }
    .preview-icon {
      display: flex;
      // display: inline-block;
      // color: #ef8215;
      // border: #ef8215 solid 2px;
      // border-radius: 50%;
      // width: 20px;
      // height: 20px;
      // line-height: 1.1em;
      // text-align: center;
      // font-weight: 500;
      $img-size: 20px;
      width: $img-size;
      height: $img-size;
      img {
        width: 100%;
      }
    }
  }
}
.orderCheckbox {
  border: #ef8215 solid 3px;
  padding: 1px;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  &.checked::after {
    content: '';
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #ef8215;
    display: block;
  }
}
.like-count {
  display: flex;
  color: rgba(96, 125, 138, 0.6);
  &.user-like {
    color: rgba(95, 172, 54, 1);
  }
  span {
    font-size: 0.95em;
  }
  i {
    margin-right: 10px;
    font-size: 1.3em;
  }
}
</style>
